<div class="insights-page">
  <div class="insights-shell">
    <header class="insights-hero">
      <div class="insights-hero-copy">
        <h1>Settings</h1>
        <p class="insights-lead">
          Manage agent access, navigation preferences, and appearance.
        </p>
      </div>
    </header>

  <section class="settings-section">
    <div class="d-flex align-items-center justify-content-between">
      <h2 class="section-title">Agent access</h2>
    </div>
    <hr />
    <div class="card setting-card">
      <div class="card-body d-flex align-items-center justify-content-between gap-3">
        <div>
          <div class="setting-title">Agent tokens</div>
          <div class="setting-desc">
            Create scoped tokens for AI agents to track time and read projects on your behalf.
          </div>
        </div>
        <a routerLink="/settings/agent-tokens" class="btn btn-primary">Manage tokens</a>
      </div>
    </div>
  </section>

  <section class="settings-section">
    <div class="d-flex align-items-center justify-content-between">
      <h2 class="section-title">Appearance</h2>
    </div>
    <hr />
    <div class="card setting-card">
      <div class="card-body">
        <div class="setting-title mb-2">Color theme</div>
        <div class="setting-desc mb-3">Choose a theme for the application interface.</div>

        <div class="theme-options">
          <label class="theme-tile">
            <input type="radio" name="theme" value="light" (change)="onThemeChange('light')" [checked]="(theme.currentTheme$ | async) === 'light'" />
            <div class="tile-visual light">
              <div class="tile-header"></div>
              <div class="tile-body"></div>
            </div>
            <div class="tile-label">Light</div>
          </label>

          <label class="theme-tile">
            <input type="radio" name="theme" value="dark" (change)="onThemeChange('dark')" [checked]="(theme.currentTheme$ | async) === 'dark'" />
            <div class="tile-visual dark">
              <div class="tile-header"></div>
              <div class="tile-body"></div>
            </div>
            <div class="tile-label">Dark</div>
          </label>

          <label class="theme-tile">
            <input type="radio" name="theme" value="system" (change)="onThemeChange('system')" [checked]="(theme.currentTheme$ | async) === 'system'" />
            <div class="tile-visual system">
              <div class="tile-header"></div>
              <div class="tile-body"></div>
            </div>
            <div class="tile-label">System</div>
          </label>

        </div>
      </div>
    </div>
  </section>
  </div>
</div>
